import React from 'react';
import { FadeIn } from './FadeIn';
export function Team() {
  const team = [{
    name: 'Dr. Martín Lagos',
    specialty: 'Implantología y Cirugía',
    bio: 'Especialista en rehabilitaciones complejas con más de 10 años de experiencia internacional.',
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    name: 'Dra. Valentina Reyes',
    specialty: 'Ortodoncia Invisible',
    bio: 'Certificada en sistemas de alineadores transparentes. Apasionada por la armonía facial.',
    image: 'https://cdn.magicpatterns.com/uploads/m5XFYGmDJhMJuvn5W3H5ad/Imagen_6.png'
  }, {
    name: 'Dra. Camila Herrera',
    specialty: 'Estética Dental',
    bio: 'Experta en diseño de sonrisa digital y carillas de porcelana mínimamente invasivas.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    name: 'Dr. Alejandro Ruiz',
    specialty: 'Endodoncia Microscópica',
    bio: 'Especialista en salvar piezas dentales mediante tecnología de magnificación.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }];
  return <section id="equipo" className="py-24 relative" data-id="element-185">
      <div className="max-w-7xl mx-auto px-6" data-id="element-186">
        <FadeIn className="text-center max-w-2xl mx-auto mb-16" data-id="element-187">
          <h2 className="text-4xl md:text-5xl font-black text-nova-dark mb-6 tracking-tight" data-id="element-188">
            Profesionales de Excelencia
          </h2>
          <p className="text-lg text-nova-gray" data-id="element-189">
            Un equipo multidisciplinario altamente capacitado, trabajando en
            conjunto para brindarte la mejor atención.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-190">
          {team.map((member, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-191">
              <div className="glass-panel p-4 group" data-id="element-192">
                <div className="relative h-64 rounded-2xl overflow-hidden mb-6" data-id="element-193">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-194" />
                  <div className="absolute inset-0 bg-nova-cyan/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 mix-blend-overlay" data-id="element-195"></div>
                </div>
                <div className="px-2 pb-4" data-id="element-196">
                  <h3 className="text-xl font-bold text-nova-dark mb-1" data-id="element-197">
                    {member.name}
                  </h3>
                  <p className="text-nova-cyan font-medium text-sm mb-3" data-id="element-198">
                    {member.specialty}
                  </p>
                  <p className="text-nova-gray text-sm leading-relaxed" data-id="element-199">
                    {member.bio}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}